module.exports = __webpack_public_path__ + "static/img/login-bg.5ba50eff.png";